import { motion } from 'framer-motion';
import { mockData } from '../mock';

export const Marquee = () => {
  const text = mockData.marquee.text;
  const repeatedText = Array(20).fill(text).join('   ');

  return (
    <section className="relative py-12 bg-gradient-to-r from-amber-400 to-amber-500 overflow-hidden">
      <motion.div
        animate={{ x: [0, -1920] }}
        transition={{
          duration: 40,
          repeat: Infinity,
          ease: "linear"
        }}
        className="flex whitespace-nowrap"
      >
        <span className="text-4xl md:text-6xl font-bold text-slate-950 tracking-wider">
          {repeatedText}
        </span>
      </motion.div>
    </section>
  );
};
